export default {
  path: 'push',
  meta: {
    title: '财务推送'
  },
  component: () => import('@/components/parent-view'),
  name: 'push',
  children: [
    {
      path: 'importOrder',
      name: 'import-order',
      meta: {
        title: '导入订单推送'
      },
      component: () => import('@/view/v5/push/importOrder/importOrder.vue')
    },
    {
      path: 'settings',
      name: 'settings',
      meta: {
        title: '推送设置'
      },
      component: () => import('@/view/v5/push/settings/settings.vue')
    },
    {
      path: 'task',
      name: 'task',
      meta: {
        title: '推送任务'
      },
      component: () => import('@/view/v5/push/task/task.vue')
    },
    {
      path: 'logList',
      name: 'logList',
      meta: {
        title: '日志查看'
      },
      component: () => import('@/view/v5/push/logList/logList.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/push.js